<script lang="ts">
  import { getCopy } from "../../lib/stores/copy";
  import BaseCard from "../Card/BaseCard.svelte";
  import { navigateToPath } from "../../lib/routing";
  import PATHS from "../../lib/constants/routePaths";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import Typography from "../Typography.svelte";
  import { groupBundleItems, isMenuFullySpecified } from "../../lib/helpers/steps/bundleSelection";
  import { getCampaignUser } from "../../lib/helpers/campaignUserManager";
  import LoadingScreen from "../LoadingScreen.svelte";
  import { sessionStore } from "../../lib/stores/session";

  export let hideEditButton: boolean = false;
  let isLoading = true;
  let image: string | undefined;
  let description: string | undefined;

  const onEditClick = () => navigateToPath(PATHS.MENU);

  $: copy = $getCopy("review") as Record<string, string>;
  $: groupItems = groupBundleItems();
  $: internalHideEditButton = isMenuFullySpecified($sessionStore.socialGiftBundleMenuItems || []) || hideEditButton; 
  $: {
    void (async () => {
      isLoading = true;
      const campaignUser = await getCampaignUser(); // Should be immediate when going through the flow  
      image = campaignUser?.metadata?.social_gift_bundle?.image; // FIXME: should we have some default artwork?
      description = campaignUser?.metadata?.social_gift_bundle?.description;
      isLoading = false;
    })();
  }
</script>

<BaseCard headerCopy={copy.selectedGiftHeaderCopy} {onEditClick} hideEditButton={internalHideEditButton}>
  <svelte:fragment slot="card body">
    {#if isLoading}
      <LoadingScreen />
    {:else}
      <div class="flex flex-row gap-4">
        {#if image}
          <div
            class="bg-cover bg-center rounded-lg block h-20 w-20"
            role="img"
            aria-label={image}
            style={`background-image: url("${image}");`}>
          </div>
        {/if}
        <div class="flex flex-col gap-3 justify-start">
          <div class="flex flex-col">
            {#if description}
              <div class="mb-2">
                <Typography mobile={TypographyType.Headline5} desktop={TypographyType.Headline4}>
                  {description}
                </Typography>
              </div>
            {/if}
            {#each groupItems as item}
              <Typography mobile={TypographyType.Body1Medium} desktop={TypographyType.Headline5Medium}>
                {item.count}x {item.visibleName}
                {#if item.menuItem?.variations.length && item.menuItem?.variations.length > 1}
                  ({item.visibleVariation})
                {/if}
              </Typography>
            {/each}
          </div>
        </div>
      </div>
    {/if}
  </svelte:fragment>
</BaseCard>
